"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));
var _core = require("@material-ui/core");
var _pittaModules = require("@thingsw/pitta-modules");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    colorDefault: {
      backgroundColor: _pittaModules.LightColors.primary["0"],
      borderBottom: "1px solid ".concat(_pittaModules.LightColors.primary["6"])
    },
    colorTransparent: {
      background: "".concat(_pittaModules.LightColors.primary["0"], "CD")
    }
  };
});
var AppBar = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_AppBar.default, _extends({
    position: "fixed",
    elevation: 0,
    ref: ref,
    classes: classes
  }, props));
});
exports.AppBar = AppBar;